import { showConfirmModal } from '@clickbar/tailwindui-vue'

import { requestLocalCacheReset } from '@/persistence'

/**
 * Asks for confirmation, then clears the locally persisted collection data and reloads it.
 */
export async function resetLocalCache(): Promise<void> {
  const confirmed = await showConfirmModal(
    'Lokalen Cache zurücksetzen?',
    'Die lokal gespeicherten Daten werden gelöscht und neu geladen. Das kann einen Moment dauern.',
    {
      positiveText: 'Zurücksetzen',
      negativeText: 'Abbrechen',
    },
  )

  if (confirmed) {
    requestLocalCacheReset()
  }
}
